module.exports = __webpack_public_path__ + "static/media/r.e2294f2a.png";